<template>
  <div id="app">
    <div v-wechat-title="$route.name"></div>
    <!--控制微信标题的-->
    <router-view />
  </div>

</template>

<script>
// import $ from 'jquery'
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue